import httpService from "app/services/httpService";
import config from "../../../src/config.json";

const apiUrl = config.apiUrl;

const getCreditTransactionHisory = async (query) => {
  const data = await httpService.get(
    `${apiUrl}/members/transaction-history${query ? `?${query}` : ""}`
  );
  return data;
};

const getrequisition = async (query) => {
  const data = await httpService.get(
    `${apiUrl}/requisition/all/${query ? `?${query}` : ""}`
  );
  return data;
};

const exportRequisition = async (queryString) => {
  try {
    const url = `${apiUrl}/requisition/all/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};

const getAllCreditReports = async (query) => {
  const data = await httpService.get(
    `${apiUrl}/requisition/search-all-credit-requisition${
      query ? `?${query}` : ""
    }`
  );
  return data;
};

const getrequisitionForEdit = async (ReqId) => {
  const { data } = await httpService.get(
    `${apiUrl}/requisition/requsition/${ReqId}`
  );
  return data;
};

const approveReq = async (value) => {
  try {
    const url = `${apiUrl}/requisition/approve`;
    const { data } = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

const approveReqByDistributor = async (value) => {
  try {
    const url = `${apiUrl}/requisition/approve-by-distributor`;
    const { data } = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

const declineReq = async (value) => {
  try {
    const url = `${apiUrl}/requisition/decline`;
    const { data } = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

const declineReqByDistributor = async (value) => {
  try {
    const url = `${apiUrl}/requisition/decline-by-distributor`;
    const { data } = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

const addRedHandler = async (value) => {
  try {
    const url = `${apiUrl}/requisition`;
    const { data } = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

const addReqToAdmin = async (value) => {
  try {
    const url = `${apiUrl}/requisition/admin-send-requisition`;
    const { data } = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

const creditSettlement = async (value) => {
  const url = `${apiUrl}/requisition/credit-balance-settlement`;
  const { data } = await httpService.post(url, value);
  return data;
};

const updateReq = async (value) => {
  try {
    const url = `${apiUrl}/requisition/admin-update-requisition`;
    const { data } = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

const reactiveReq = async (value) => {
  try {
    const url = `${apiUrl}/requisition/activate-decline-requisition`;
    const { data } = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

const exportCreditReports = async (query) => {
  try {
    const url = `${apiUrl}/members/merchants-credit-limit/export${
      query ? `?${query}` : ""
    }`;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};

const creditLimit = async (query) => {
  const data = await httpService.get(
    `${apiUrl}/members/merchants-credit-limit${query ? `?${query}` : ""}`
  );
  return data;
};

const creditWithdrawal = async (value) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/requisition/credit-balance-settlement-with-ledger`,
      value
    );
    console.log(data);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const complaintList = async (query) => {
  const data = await httpService.get(
    `${apiUrl}/billavenue/get-complaint-list${query ? `?${query}` : ""}`
  );
  return data;
};

const addComplaint = async (value) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/billavenue/bbps-complaint-registration`,
      value
    );
    console.log(data);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const trackComplaint = async (value) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/billavenue/bbps-complaint-tracking`,
      value
    );
    console.log(data);
    return data;
  } catch (error) {
    console.log(error);
  }
};
const getDistributorRequisition = async (query) => {
  const data = await httpService.get(
    `${apiUrl}/requisition/distributor-requisition-list${
      query ? `?${query}` : ""
    }`
  );
  return data;
};
const exportDistributorRequisition = async (queryString) => {
  try {
    const url = `${apiUrl}/requisition/distributor-requisition/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};

export {
  getDistributorRequisition,
  exportDistributorRequisition,
  getCreditTransactionHisory,
  getrequisition,
  exportRequisition,
  getAllCreditReports,
  getrequisitionForEdit,
  approveReq,
  approveReqByDistributor,
  declineReq,
  declineReqByDistributor,
  addRedHandler,
  addReqToAdmin,
  creditSettlement,
  updateReq,
  reactiveReq,
  exportCreditReports,
  creditLimit,
  complaintList,
  addComplaint,
  trackComplaint,
  creditWithdrawal,
};
